import * as React from 'react';
import * as RB from 'react-bootstrap';
import { RouteComponentProps } from 'react-router';
import * as DTO from '../../service/DTOs';
import * as TF from '../../service/tradeflow';

//import { Highlighter } from 'react-bootstrap-typeahead';

import 'isomorphic-fetch';




interface LimitsItemState {
    entity: DTO.EntityWLimits;
    loading?: boolean;
}

type LimitsItemProps = LimitsItemState & { xsrfToken?: string };

const initialstateEntity: LimitsItemState = {
    entity: { id:0, addressfact: '', addresslegal: '', email: '', fax: '', fullname: '', shortname: '', idcountry: 0, phone: '', reutercode: '' },
    loading: false
}



export class LimitsListItem extends React.Component<LimitsItemProps, LimitsItemProps> {
    constructor(props: LimitsItemProps) {
        super(props);
        this.state = {
            ...initialstateEntity, ...{ entity: props.entity }
        };
    }

    public render() {

        return <div>
            {this.props.entity.shortname}
            <div>
                <small><b>Название:</b>{this.props.entity.fullname}</small>
            </div>
            <div>
                <small><b>Адрес:</b>{this.props.entity.addresslegal}</small>{' '}<small><b>Reuter:</b>{this.props.entity.reutercode}</small>
                {this.props.entity.bloombergcode ? <small><b>Reuter:</b>{this.props.entity.bloombergcode }</small>: ''}
            </div>
        </div>;
    }

}

